<template>
  <div id="content">
    <el-tabs v-model="activeName" type="card" class="content-tabs" style="line-height: 20px;">
      <el-tab-pane label="导出" name="first"></el-tab-pane>
      <el-tab-pane label="导入" name="second"></el-tab-pane>
    </el-tabs>
    <export-tab v-if="activeName==='first'"></export-tab>
    <import-tab v-if="activeName!=='first'"></import-tab>
  </div>
</template>
<script>
import ExportTab from '../../components/common/exportTab.vue'
import ImportTab from '../../components/common/importTab.vue'
export default {
  name:'exportList',
  components:{ExportTab,ImportTab},
  data(){
    return{
      activeName: 'first'
    }
  }
}
</script>



